const SELL_HOMERISE_BASE_URL = 'https://sell2.homerise.com/'

const getSellHomeriseUrl = (address: string) => {
  const url = new URL(SELL_HOMERISE_BASE_URL)
  url.searchParams.set('address', address)
  return url.toString()
}

export default getSellHomeriseUrl
